import { useContext } from "react"

import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickEstimateContext from "../../../../OneClickEstimateContext"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidMetalMask from "../../../../service/visibleValidator/isValidMetalMask"

import hand from "./manual.png"
import reflow from "./reflow.png"

const 実装方法 = ({ values, handlers }: OneClickFieldProps) => {
  const { metalmask: shouldShow } = getDisplayCondition(values)
  const { metalMaskStockPartName } = useContext(OneClickEstimateContext)
  const hasGhMetalMask = !!metalMaskStockPartName

  return (
    <OneClickField isShow={shouldShow} helpURL={HELP_LINKS.実装方法} legend="実装方法">
      <RadioGroup
        name={FIELD_NAMES.実装方法}
        selectedValue={values.metalmask}
        onChange={handlers.radio}
        shouldRender={(value) => isValidMetalMask(values, value, hasGhMetalMask)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.実装方法.リフロー実装をする.value} prefixImageSrc={reflow}>
            リフロー実装をする
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.実装方法.手付実装をする.value} prefixImageSrc={hand}>
            手付実装をする
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      {/* TODO メタルマスク製造のエラーが出るためサーバーサイドのエラーメッセージを直す */}
      {/* <OneClickFieldMessages error={errors?.metalmask} /> */}
    </OneClickField>
  )
}

export default 実装方法
